import React, { useEffect } from 'react';
import Shared from 'screens/shared';
import Utilities from 'screens/shared/utilities';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { useSelector } from 'react-redux';
import { isEmptyArray } from 'utils';


export default ({ title, onItemClick }) => {
  const { [ACTIONS_TYPES.SERVER.GET_OVERALL_SERVERS]: overallServers = [] } = useSelector((e) => e);

  useEffect(() => {
    if (isEmptyArray(overallServers)) actions.server.getOverallServers();
  // eslint-disable-next-line
  }, []);

  return (
    <Shared.widgets.Section
      sectionTitle={title}
      itemIcon="server"
      setItemTitle={(e) => e?.properties?.name}
      items={overallServers}
      setItemDetails={(e) => (
        <div>
          <span className="block m-b-4 m-t-4">
            <Shared.utilities.Status state={e?.properties?.vmState} className="f-14" />
            <Shared.utilities.Separator />
            {e?.dataCenter?.properties?.name}
          </span>
          <Utilities.Location location={e?.dataCenter?.properties?.location} className="f-14" />
        </div>
      )}
      itemOnClick={(e) => onItemClick(e)}
    />
  );
};
